import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchResultTab } from './search-result-tab.component';

import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import {
  clearRecentSearches,
  useSearchState,
} from '@/store/search/search.store';
import { useRecentSearchesStorage } from '@/storage/recents-searches.storage';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { Button } from '@/components/ui/button/button.component';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { Typography } from '@/components/ui/typography/typography.component';

export interface RecentSearchesProps {
  setOpen: (open: boolean) => void;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
  locationOverride?: OverridedUserLocation;
}

export const RecentSearched = ({
  selectLaboratoryProcedure,
  setOpen,
  locationOverride,
}: RecentSearchesProps) => {
  const recentSearches
    = useStore(useSearchState, (state) => state?.recentSearches) ?? [];
  const [, setStoredRecentSearches] = useRecentSearchesStorage();
  const analytics = getAnalyticsPlugin();

  if (!recentSearches.length) {
    return null;
  }

  function handleSelectProcedure(procedure: SelectedProcedures): void {
    if (selectLaboratoryProcedure) {
      selectLaboratoryProcedure(procedure);
    }

    analytics.track(AnalyticsEnum.CLICK_LAST_SEARCHED_ITEM);
  }

  return (
    <div
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_RECENT_SEARCHES_CONTAINER}
    >
      <div className="flex flex-row justify-between mt-3 px-6">
        <Typography className="text-nowrap font-semibold">
          Pesquisas recentes
        </Typography>
        <Button
          variant="text"
          className="text-green-500 text-sm font-semibold cursor-pointer w-fit"
          onClick={() => clearRecentSearches(setStoredRecentSearches)}
          data-testid={
            DataTestIdEnum.PROCEDURES_MODAL_RECENT_SEARCHES_CLEAR_BUTTON
          }
          data-analytics-event={AnalyticsEnum.CLICK_CLEAR_LAST_SEARCHES}
        >
          Limpar
        </Button>
      </div>
      <div>
        {recentSearches.map((search) => (
          <div
            key={`key-recent-searches-${search.id}`}
            className="hover:bg-gray-50 transition-colors"
          >
            <SearchResultTab
              {...search}
              setOpen={setOpen}
              selectLaboratoryProcedure={handleSelectProcedure}
              locationOverride={locationOverride}
              inRecentSearch={true}
            />
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};
